import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  editTask: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignContent: "center",
    backgroundColor: "white",
    marginTop: theme.spacing(1),
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    borderWidth: "medium",
    padding: theme.spacing(2),
  },
  textfield: {
    margin: theme.spacing(1),
  },
  buttonGroup: {
    paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    margin: theme.spacing(1),
  },
  cancel: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
    outlined: theme.palette.primary.main,
    marginRight: theme.spacing(3),
    flexGrow: 1,
  },
  done: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    outlined: theme.palette.primary.main,
    marginLeft: theme.spacing(3),
    flexGrow: 1,
    "&:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export default useStyles;
